import { render, staticRenderFns } from "./CustomerOrderButton.vue?vue&type=template&id=b7da6820"
import script from "./CustomerOrderButton.vue?vue&type=script&lang=js"
export * from "./CustomerOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports